import { ark } from '@ark-ui/react/factory'
import { Popover as ArkPopover } from '@ark-ui/react/popover'
import { buttonDescription, description } from '../popover/popover.styles'

export type DescriptionProps = React.ComponentProps<typeof ark.span> & {
  hasPopoverButton?: boolean
}

export function PopoverDescription({
  className,
  hasPopoverButton,
  ...props
}: DescriptionProps) {
  return (
    <ArkPopover.Description asChild>
      <ark.span
        {...props}
        className={hasPopoverButton ? buttonDescription() : description()}
      />
    </ArkPopover.Description>
  )
}

PopoverDescription.displayName = 'PopoverDescription'
